let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dta3s")).then(() => parcelRequire('6EtFI'));